import { AbstractControl } from "@angular/forms";

export function belgianNationalRegistryNumberValidator(control: AbstractControl): { format?: boolean } | null {
	if (!control.value) {
		return null;
	}

	const value = String(control.value);
	if (value.length !== 11) {
		return { format: false };
	}

	const dateRegex = /\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])/; // YYMMDD
	if (!dateRegex.test(value)) {
		return { format: false };
	}

	const sequence = value.substring(6, 9);
	if (sequence === "000" || sequence === "999") {
		return { format: false };
	}

	const year = Number(value.substring(0, 2));
	const currentYear = new Date().getFullYear();
	const checksumInputPrefix = currentYear - year < 2000 ? "" : "2";
	const checksumInput = Number(`${checksumInputPrefix}${value.substring(0, 9)}`);
	const givenChecksum = Number(value.substring(9, 11));
	const calculatedChecksum = 97 - (checksumInput % 97);

	if (givenChecksum !== calculatedChecksum) {
		return { format: false };
	}

	return null;
}
